export default {
	sidebar: {
		admin_header: 'Administration',
		hr_header: 'Personalverwaltung',
		staff_header: 'Crew-Leitung',
		//
		user_dashboard: 'Übersicht',
		user_events: 'Veranstaltungen',
		user_calendar: 'Kalender',
		user_profile: 'Profil',
		user_documents: 'Dokumente',
		user_timetracking: 'Zeiterfassung',
		user_mails: 'Nachrichten',
		//
		staff_crews: 'Crews',
		staff_timetracking: 'Zeiterfassung',
		staff_staffing_requests: 'Personalanfragen',
		//
		hr_users: 'Personen',
		hr_applications: 'Bewerbungen',
		hr_staffing_requests: 'Personalanfragen',
		hr_subscriptions: 'Abos',
		hr_events: 'Veranstaltungen',
		hr_crews: 'Crews',
		hr_staff_crews: 'Crews',
		hr_schedule_employees: 'Personalplanung',
		hr_contracts: 'Verträge',
		hr_payroll: 'Lohnabrechnung',
		hr_mails: 'Nachrichten',
		//
		admin_users: 'Personen',
		admin_settings: 'Einstellungen',
	},
	// Kurze Titel (Tooltips) für Schaltflächen ohne sichtbare Beschriftung. Nur wenige Worte, sie
	// müssen der Person lediglich sagen, was die Schaltfläche tut. Alles Allgemeine steht bereits in
	// der lib, hier gehört nur hinein, was diese App darüber hinaus braucht.
	buttons: {
		driving_license: {
			check: 'Als gesichtet vermerken',
			uncheck: 'Vermerk zurücknehmen',
		},
		quick_registration: {
			copy: 'Link kopieren',
			open: 'Seite öffnen',
			renew: 'Neuen Link erzeugen',
			download_qr: 'QR-Code herunterladen',
		},
		application: {
			accept: 'Bewerbung annehmen',
			decline: 'Bewerbung ablehnen',
			waiting: 'Auf die Warteliste setzen',
			publish: 'Zu- oder Absage senden',
			publish_all: 'Alle Zu- und Absagen senden',
			info: 'Bewerbung ansehen',
			revoke: 'Bewerbung zurückziehen',
		},
		calendar: {
			date_create: 'Termin erstellen',
			date_delete: 'Termin löschen',
		},
		contract: {
			apply_start: 'Startdatum auf die Auswahl übertragen',
			apply_end: 'Enddatum auf die Auswahl übertragen',
			apply_wage: 'Stundenlohn auf die Auswahl übertragen',
			generate_all: 'Verträge der Auswahl erzeugen',
			send_all: 'Verträge der Auswahl senden',
			generate: 'Vertrag erzeugen',
			preview: 'Vertrag ansehen',
			send: 'Vertrag senden',
			sign: 'Als unterschrieben markieren',
			delete: 'Entwurf löschen',
			template_select: 'Vorlage auswählen',
			template_upload: 'Vorlage hochladen',
		},
		crew: {
			create: 'Crew erstellen',
			edit: 'Crew bearbeiten',
			delete: 'Crew löschen',
			open: 'Crew öffnen',
			publish: 'Crew veröffentlichen',
			unpublish: 'Crew verbergen',
			rate: 'Erfahrung der Crew eintragen',
		},
		event: {
			mail: 'Der Veranstaltung schreiben',
			publish: 'Veranstaltung veröffentlichen',
			unpublish: 'Veranstaltung verbergen',
			applications_enable: 'Bewerbung öffnen',
			applications_disable: 'Bewerbung schließen',
			unlock: 'Veranstaltung entsperren',
			sort: 'Veranstaltungen sortieren',
			route: 'Route planen',
			lock: 'Veranstaltung sperren',
		},
		file: {
			open: 'Datei öffnen',
			download: 'Datei herunterladen',
			edit: 'Dateityp bearbeiten',
			delete: 'Datei löschen',
		},
		mail: {
			compose: 'Nachricht schreiben',
			reply: 'Antworten',
			load_more: 'Ältere laden',
		},
		occupation: {
			create: 'Beschäftigung hinzufügen',
			edit: 'Beschäftigung bearbeiten',
			delete: 'Beschäftigung löschen',
		},
		payroll: {
			export: 'LODAS-Datei herunterladen',
			take_hours: 'Erfasste Stunden übernehmen',
			save: 'Abrechnung speichern',
			check: 'Als geprüft stempeln',
		},
		planning: {
			add_employee: 'Mitarbeitende hinzufügen',
			sort_by_date: 'Nach Bewerbungsdatum sortieren',
			sort_by_name: 'Nach Vornamen sortieren',
		},
		experience: {
			create: 'Erfahrung anlegen',
			edit: 'Erfahrung bearbeiten',
			delete: 'Erfahrung löschen',
			delete_rating: 'Erfahrungseintrag entfernen',
		},
		skill: {
			create: 'Fähigkeit erstellen',
			edit: 'Fähigkeit bearbeiten',
			delete: 'Fähigkeit löschen',
		},
		staffing_request: {
			create: 'Neue Personalanfrage stellen',
			edit: 'Personalanfrage bearbeiten',
			show: 'Personalanfrage ansehen',
			delete: 'Personalanfrage löschen',
			position_add: 'Bedarfszeile hinzufügen',
			position_delete: 'Bedarfszeile entfernen',
			requirement_add: 'davon mindestens …',
			requirement_delete: 'Anforderung entfernen',
			fill_days: 'Anzahl auf alle Tage übertragen',
		},
		subscription: {
			mail_all: 'Allen Abonnenten schreiben',
			mail_event: 'Allen Abonnenten vom {event} schreiben',
			delete: 'Abo löschen',
		},
		timetracking: {
			now: 'Aktuelle Uhrzeit übernehmen',
			apply: 'Auf die Auswahl anwenden',
			confirm: 'Bestätigen',
			dispute: 'Passt nicht',
			edit: 'Zeiten ändern',
			disputed: '1 Zeit passt nicht | {count} Zeiten passen nicht',
			open: '1 Zeit offen | {count} Zeiten offen',
			delete: 'Zeiten löschen',
			clock_in: 'Einstempeln',
			clock_out: 'Ausstempeln',
		},
		user: {
			profile: 'Person anzeigen',
			mail: 'Der Person schreiben',
			delete_core_data: 'Steuer- und Lohndaten löschen',
			assign_to_event: 'Zu einer Veranstaltung hinzufügen',
		},
	},
	// Kurze Namen der Status-Symbole einer Tabelle, unter ihr von efTableLegend ausgeschrieben. Die
	// längere Erklärung bleibt in `popovers`, die Legende reicht beim Überfahren dieselbe weiter.
	legends: {
		calendar: {
			planning: 'Einsatz',
			not_available: 'Nicht verfügbar',
			date: 'Termin',
		},
		application: {
			min_age: 'Unter 18',
			minor: 'Minderjährig bei der Veranstaltung',
			age_unknown: 'Alter noch unbekannt',
			unemployed: 'Arbeitslos, bezieht Bürgergeld/ALG 1',
			quick_registration: 'Über die Schnellanmeldung',
			locked: 'Konto gesperrt',
		},
		file: {
			uploaded: 'Von mir hochgeladen',
			unread: 'Noch nicht gelesen',
			read: 'Gelesen',
		},
		timetracking: {
			qr: 'QR-Code vorhanden',
			confirmed: 'Bestätigt',
			open: 'Offen',
			disputed: 'Passt nicht',
		},
		user: {
			address_data_completed: {
				true: 'Adressdaten',
				false: 'Adressdaten fehlen',
			},
			core_data_completed: {
				true: 'Stammdaten',
				false: 'Stammdaten fehlen',
			},
			timetracking_counts: {
				none: 'Keine Zeiten',
				missing_lead: 'Crew-Leitung fehlt',
				missing_member: 'Person fehlt',
				completed: 'Zeiten bestätigt',
			},
		},
		planning: {
			preferred_crew: 'In einer bevorzugten Crew',
			other_crew: 'In einer anderen Crew',
			other_event: 'Bei einer anderen Veranstaltung',
			not_available: 'Nicht verfügbar',
			crew_closed: 'Crew arbeitet an dem Tag nicht',
			off_day: 'Kein Tag der Crew oder der Bewerbung',
			minor: 'Unter 18',
			need_met: 'Bedarf gedeckt',
			need_over: 'Mehr als benötigt',
		},
	},
	pages: {
		intern_info: {
			hint_event: 'Erscheint auf der internen Seite für alle, die bei der Veranstaltung dabei sind.',
			hint_crew: 'Erscheint auf der internen Seite für alle, die in der Crew eingeplant sind.',
			insert_example: 'Beispieltext einfügen',
			replace_title: 'Beispieltext einfügen',
			replace_text: 'Der Beispieltext ersetzt den Text im Editor. Gespeichert wird erst mit Speichern. Fortfahren?',
			// Markdown, the leads adjust the example values
			example_crew: '## Willkommen in der Crew {crew}\n\nSchön, dass du dabei bist! Hier steht alles, was du für deine Einsätze wissen musst.\n\n### Treffpunkt und Arbeitsbeginn\n\n- **Treffpunkt:** Crew-Container am Eingang Nord\n- **Arbeitsbeginn:** bitte 15 Minuten vor Schichtbeginn da sein\n- Deine Schichten findest du oben unter **Deine Einsätze** und im Kalender.\n\n### Das bringst du mit\n\n- Personalausweis\n- Feste, geschlossene Schuhe\n- Wetterfeste Kleidung\n- Eine eigene Trinkflasche\n\n### Zeiterfassung\n\nMelde dich zu Beginn und am Ende deiner Schicht bei der Crew-Leitung, sie erfasst deine Zeiten vor Ort mit deinem QR-Code. Danach findest du sie hier in der App unter **Zeiterfassung**. Bitte prüfe sie dort und bestätige sie.\n\n### Verpflegung\n\nWährend deiner Schicht bekommst du Essen und Getränke im Crew-Catering.\n\n### Fragen?\n\nWende dich an deine Crew-Leitung. Die Kontakte findest du oben unter **Deine Ansprechpartner**.',
		},
		event_settings: {
			general: {
				title: 'Allgemein',
				image: 'Vorschaubild',
				save_first: 'Erst speichern, dann Bild hochladen',
				address_data: 'Adressdaten',
				display: 'Darstellung',
			},
			crews: {
				title: 'Crews',
			},
			applications: 'Bewerbungen',
			quick_registration: {
				status: 'Status & Link',
				enabled: 'Schnellanmeldung eingeschaltet',
				enabled_hint:
					'Über den Link melden sich Personen ohne Konto direkt für diese Veranstaltung an. Konto und Bewerbung entstehen dabei automatisch.',
				closed: {
					deadline: 'Die Seite nimmt keine Anmeldungen mehr an: Der Anmeldeschluss am {date} ist vorbei.',
					applications:
						'Die Seite nimmt keine Anmeldungen an, weil Bewerbungen für die Veranstaltung nicht freigegeben sind.',
					applications_link: 'Zu den Veranstaltungen',
					locked: 'Die Seite nimmt keine Anmeldungen an, weil die Veranstaltung gesperrt ist.',
					closed: 'Die Seite nimmt gerade keine Anmeldungen an: Der Anmeldeschluss ist vorbei, Bewerbungen sind für die Veranstaltung nicht freigegeben oder die Veranstaltung ist gesperrt.',
					ended: 'Die Veranstaltung ist vorbei, die Seite nimmt keine Anmeldungen mehr an.',
				},
				not_published:
					'Die Veranstaltung ist nicht veröffentlicht. Wer sich anmeldet, sieht sie erst nach der Veröffentlichung in seinem Konto.',
				link: 'Link zur Anmeldeseite',
				link_inactive: 'Der Link funktioniert erst, wenn die Schnellanmeldung eingeschaltet und gespeichert ist.',
				no_link: 'Der Link entsteht, sobald die Schnellanmeldung das erste Mal eingeschaltet und gespeichert wird.',
				copied: 'Link kopiert',
				closes_at: 'Anmeldeschluss',
				closes_at_hint: 'Optional. Danach zeigt die Seite, dass die Anmeldung geschlossen ist.',
				design: 'Gestaltung',
				primary_color: 'Primärfarbe',
				theme: 'Darstellung',
				themes: {
					auto: 'Wie im Gerät eingestellt',
					light: 'Hell',
					dark: 'Dunkel',
				},
				background: 'Hintergrundbild',
				background_hint:
					'Großes Bild im Kopf der Seite, am besten im Querformat ab 1600 px Breite. Als Logo erscheint das Logo der Veranstaltung.',
				texts: 'Texte',
				texts_hint:
					"Leere Felder zeigen den grauen Standardtext. {'{'}event{'}'} wird durch den Namen der Veranstaltung ersetzt, Zeilenumbrüche bleiben erhalten.",
				text: {
					title: 'Überschrift',
					subtitle: 'Unterzeile',
					intro: 'Einleitung',
					consent: 'Einwilligung',
					success: 'Text nach dem Absenden',
					mail_subject: 'Betreff',
					mail_body: 'Text der Mail',
				},
				sections: 'Abschnitte',
				closing_texts: 'Abschluss',
				section_title: 'Überschrift',
				section_text: 'Text',
				section_fields: 'Zusätzlich abfragen',
				field: {
					crews: 'Bevorzugte Crews',
					skills: 'Fähigkeiten',
					shoe_size: 'Schuhgröße',
					motivation: 'Diesen Abschnitt zeigen',
				},
				mail: 'Bestätigungsmail',
				mail_hint:
					"Absätze trennst du mit einer Leerzeile. {'{'}firstname{'}'} und {'{'}event{'}'} werden ersetzt. Darunter folgen immer der Link zum Festlegen des Passworts und die Liste der noch fehlenden Unterlagen.",
			},
			users: {
				title: 'Personen',
			},
		},
		crew_settings: {
			ratings: {
				hint: 'Nur HR sieht die Erfahrung, die du einträgst, die Person selbst nicht. Jeder Stern wird sofort gespeichert, ein Klick auf denselben Stern nimmt ihn zurück.',
				not_yet: 'Erfahrung eintragen geht ab dem {date}, dem Beginn der Veranstaltung.',
				search: 'Name suchen',
				progress: '{rated} von {total} eingetragen',
				no_experiences: 'Es sind noch keine Erfahrungen angelegt, die du eintragen könntest.',
				no_members: 'In dieser Crew ist noch niemand eingeteilt.',
				no_match: 'Niemand passt zur Suche.',
				person: 'Person',
				days: 'kein Einsatztag | 1 Einsatztag | {count} Einsatztage',
				rated_by: 'Eingetragen von {name}',
			},
			applications: 'Bewerbungen',
			users: {
				title: 'Personen',
			},
			planning: {
				title: 'Personalplanung',
				no_days: 'Die Crew hat keine Tage, an denen geplant werden könnte.',
				search: 'Name oder FetSy-Code',
			},
		},
		admin_settings: {
			datev: {
				accountant_id: 'Beraternummer',
				client_id: 'Mandantennummer',
				occupation_id: 'Tätigkeitsschlüssel Helfer',
				health_insurance_id: 'Krankenkassen Nummer',
				wage_type_normal: 'Lohnart für geleistete Stunden',
				wage_type_tip: 'Lohnart für Trinkgeld',
				wage_type_travel: 'Lohnart für Reisekosten',
			},
			experiences: {
				title: 'Erfahrungen',
				hint: 'Crew-Leitungen tragen während oder nach einem Einsatz mit 1 bis 5 Sternen ein, wie viel Erfahrung ihre Leute hierin haben. Anders als die Fähigkeiten gibt die Person sie nicht selbst an und sieht sie nie.',
				in_use: 'Wird in Erfahrungseinträgen oder Personalanfragen verwendet und kann nicht gelöscht werden',
			},
			user_dashboard: 'Startseite',
			user_skills: 'Fähigkeiten',
			contracts: {
				title: 'Verträge',
				cc_mail: 'E-Mail-Adresse für den Kopieversand',
				template: 'Upload der Vertragsvorlage',
			},
		},
		user_settings: {
			anonymized: 'Diese Person ist anonymisiert. Ihre Daten können nicht mehr geändert werden.',
			experiences: {
				private_hint: 'Nur für HR sichtbar. Die Person sieht weder ihre Stufen noch die Einträge.',
				levels: 'Stufen',
				level: 'Stufe',
				basis: 'Grundlage',
				override: 'HR-Wert',
				override_hint:
					'Ein HR-Wert ersetzt den Durchschnitt der Einträge. Ein Klick auf denselben Stern nimmt ihn zurück.',
				override_for: 'HR-Wert für {name}',
				no_experiences: 'Es sind noch keine Erfahrungen angelegt. Das geht in den Einstellungen.',
				not_rated: 'Noch keine Erfahrung eingetragen',
				average: 'kein Eintrag | Ø {average} aus 1 Eintrag | Ø {average} aus {count} Einträgen',
				overridden: 'von HR festgelegt',
				ratings: 'Erfahrungseinträge',
				no_ratings:
					'Noch keine Einträge. Crew-Leitungen tragen die Erfahrung ihrer Leute während oder nach einem Einsatz ein.',
				when: 'Zeitraum',
				event: 'Veranstaltung',
				crew: 'Crew',
				stars: 'Sterne',
				rated_by: 'Eingetragen von',
			},
			//contracts: 'Verträge',
			applications: 'Bewerbungen',
			subscriptions: 'Abos',
			events: 'Veranstaltungen',
			contracts: {
				title: 'Verträge',
				general: 'Allgemein',
				active_contract: 'Aktiver Vertrag',
			},
		},
		user: {
			event_intern: {
				welcome: 'Wir freuen uns auf deine Unterstützung. Bald bekommst du mehr Infos von uns.',
				days: 'Deine Einsätze',
				to_calendar: 'Im Kalender ansehen',
				today: 'Heute',
				contacts: 'Deine Ansprechpartner',
				crew: 'Crew {name}',
				manager: 'Crew-Leitung',
				no_managers: 'Für diese Crew ist noch keine Leitung eingetragen.',
				call: 'Anrufen',
				mail: 'E-Mail schreiben',
				save_contact: 'Kontakt speichern',
				info: 'Informationen',
				crew_info: 'Informationen für die Crew {name}',
				edit_info: 'Informationen bearbeiten',
				documents: 'Dokumente',
				documents_hint:
					'Erscheinen auf der internen Seite unter dem Text dieser Informationen. PDF, Bilder, Office-Dateien und Text bis 20 MB.',
				delete_document: 'Dokument löschen',
				delete_document_text: 'Soll das Dokument „{name}" wirklich gelöscht werden?',
				no_crew_info:
					'Noch keine Informationen für deine Crew. Was hier steht, sehen alle, die in der Crew eingeplant sind.',
			},
			events: {
				title: 'Veranstaltungen',
				sort_by: 'Sortierung',
				sort_by_date: 'Nach Datum',
				sort_by_name: 'Nach Name',
				show_past_events: 'Vergangene Veranstaltungen anzeigen',
				apply_now: 'Jetzt bewerben',
				already_applied: 'Du hast dich beworben.',
				not_accepted: 'Bewerbung nicht ausgewählt',
				complete_now: 'Bewerbung jetzt vervollständigen',
				completed: 'Bewerbung erfolgreich abgeschlossen',
				revoked: 'Du hast deine Bewerbung zurückgezogen',
				added: 'Du wurdest hinzugefügt',
				crew_lead: 'Du leitest eine Crew',
				application_not_enabled: 'Bewerbung wird bald freigeschaltet',
				locked: 'Bewerbung nicht mehr möglich',
			},
			apply: {
				production: 'Möglicher Einsatzzeitraum',
				show: 'Veranstaltung',
				availability: 'Verfügbarkeit',
				available_all_the_time: 'Ich bin über den gesamten Einsatzzeitraum verfügbar',
				favorit_crews: 'Wähle die Crews aus, für die du dich besonders interessierst',
				is_favorit_crew: 'Ich interessiere mich für diese Crew.',
				//
				back: 'Zurück',
				next: 'Weiter',
				//
				step: 'Schritt',
				//
				crew: 'Crew wählen',
				motivation: 'Motivation',
				contact: 'Kontaktdaten',
				qualification: 'Qualifikation',
				send: 'Bewerbung abschicken',
				accept: 'Job annehmen',
				core_data: 'Steuer- und Lohndaten',
				core_data_why:
					'Diese Angaben brauchen wir für deinen Vertrag und die Lohnabrechnung, wenn du dabei bist. Du findest sie in der Mitteilung deiner Steuer-ID und auf deinem Sozialversicherungsausweis.',
				edit: 'Bewerbung aktualisieren',
				revoke: 'Bewerbung zurückziehen',
				student_documents: 'Dokumente',
				student_documents_info: 'Da du Student/in bist, benötigen wir folgende Dokumente von dir.',
				student_documents_skip: 'Ich reiche die Dokumente später nach.',
				versicherungsbestaetigung: 'Versicherungsbestätigung',
				immatrikulationsbescheinigung: 'Immatrikulationsbescheinigung',
				parental_consent: 'Einverständnis',
				parental_consent_info:
					'Du bist bei der Veranstaltung noch nicht 18. Für deinen Vertrag brauchen wir die Einverständniserklärung deiner Erziehungsberechtigten.',
				parental_consent_document: 'Einverständniserklärung der Erziehungsberechtigten',
				parental_consent_contents:
					'Die Erklärung tragen deine Erziehungsberechtigten mit ihrer Unterschrift, deinem Namen und der Veranstaltung. Ein Foto oder Scan genügt.',
				parental_consent_later: 'Ich reiche die Erklärung später nach.',
				parental_consent_needed: 'Lade die Erklärung hoch oder hake an, dass du sie später nachreichst.',
				//
				motivation_text: 'Was ist deine Motivation auf dieser Veranstaltung zu Arbeiten?',
				experience_text:
					'Hast du schon einmal für uns, auf dieser Veranstaltung oder auf einer anderen Veranstaltung gearbeitet? Wenn ja, welche Veranstaltung war das und was hast Du gemacht?',
				confirmation:
					'Hiermit bestätige ich die Richtigkeit der eingegebene Daten und bewerbe mich für die Veranstaltung. Der genaue Einsatzzeitraum wird erst in einem folgenden Schritt genauer festgelegt.',
			},
			documents: {
				title: 'Dokumente',
			},
			mails: {
				title: 'Nachrichten',
				empty: 'Keine Nachrichten',
			},
			timetracking: {
				title: 'Zeiterfassung',
			},
		},
		hr: {
			applications: {
				title: 'Bewerbungen',
				publish: 'Zu- und Absagen versenden',
			},
			events: {
				title: 'Veranstaltungen',
			},
			subscriptions: {
				title: 'Abos',
			},
			persons: {
				title: 'Personen',
			},
			contracts: {
				title: 'Verträge',
				start_at: 'Startdatum',
				end_at: 'Enddatum',
				wage: 'Stundenlohn',
				no_template: 'Es wurde noch keine Vertragsvorlage hochgeladen.',
				no_template_hint: 'Solange keine Vorlage vorhanden ist, können keine Verträge erzeugt werden.',
				no_template_action: 'Vorlage hochladen',
			},
			payroll: {
				title: 'Lohnabrechnung',
				checked: 'Geprüft',
				checked_at: 'Geprüft am {date}. Ein Klick nimmt die Prüfung zurück.',
				exported: 'Exportiert',
				exported_at: 'Exportiert am {date}',
				exported_toast: 'LODAS-Datei exportiert',
				nothing_to_export: {
					title: 'Nichts zu exportieren',
					text: 'Im {month} gibt es keine geprüfte Abrechnung, die noch in keinem Export war. Hake zuerst die fertigen Zeilen als geprüft ab.',
				},
				not_ready: {
					no_hours: 'Noch keine Stunden: ohne Stunden lässt sich die Zeile nicht abhaken.',
					data_incomplete: 'Kontakt- oder Stammdaten fehlen noch, erst dann lässt sich die Zeile abhaken.',
					times_open: 'Noch nicht alle Zeiten des Monats sind von beiden Seiten bestätigt.',
				},
				errors: {
					title: 'Abrechnung nicht geändert',
					payslip_locked: 'Die Abrechnung ist geprüft oder exportiert und lässt sich nicht mehr ändern.',
					payslip_exported: 'Die Abrechnung ist schon exportiert, das Häkchen bleibt.',
					payslip_not_ready: 'Die Abrechnung gehört zu keiner Person mehr.',
					payslip_no_hours: 'Ohne Stunden lässt sich die Abrechnung nicht abhaken.',
					payslip_data_incomplete: 'Kontakt- oder Stammdaten der Person fehlen noch.',
					payslip_times_open: 'Noch nicht alle Zeiten des Monats sind von beiden Seiten bestätigt.',
				},
				check: 'Prüfen',
				filter: {
					all_events: 'Alle Veranstaltungen',
					states: {
						all: 'Alle Abrechnungen',
						open: 'Offen',
						checked: 'Geprüft',
						not_exported: 'Nicht exportiert',
					},
				},
			},
			planning: {
				may_drive: 'Darf {class} fahren',
				not_planned: 'Nicht eingeteilt',
				title: 'Personalplanung',
			},
			staffing_requests: {
				title: 'Personalanfragen',
			},
			mail: {
				title: 'Nachrichten',
				search: 'Person oder Betreff suchen',
				read: 'Gelesen',
				read_at: 'Gelesen {date}',
				unread: 'Ungelesen',
			},
		},
		staff: {
			crews: {
				title: 'Crew-Leitungen',
			},
			staffing_requests: {
				title: 'Personalanfragen',
				empty: 'Du hast noch keine Personalanfrage gestellt.',
			},
			timetracking: {
				title: 'Zeiterfassung',
			},
		},
		profile: {
			contact_data: 'Kontaktdaten',
			address_data: 'Adresse',
			additional_information: 'Weitere Informationen',
			additional_personal_data: 'Weitere persönliche Daten',
			declarations_for_taxes: 'Angaben zur steuerlichen Einstufung',
			bank_details: 'Bankverbindung',
			check_fields: 'Nicht gespeichert - bitte prüfe die markierten Felder',
			apprenticeship: 'Ausbildung',
			skills: 'Fähigkeiten',
			additional_occupation: 'Weitere Beschäftigungen',
			driving_license: 'Führerschein',
			driving_license_checked: 'Führerschein gesichtet',
			driving_license_unchecked: 'Führerschein noch nicht gesichtet',
			driving_license_save_first: 'Erst die geänderten Klassen speichern',
		},
		quick_registration: {
			defaults: {
				title: 'Anmeldung {event}',
				subtitle: 'Werde Teil unseres Teams',
				intro: 'Melde dich hier für {event} an. Wir fragen alles ab, was wir für deinen Vertrag und die Lohnabrechnung brauchen. Danach hast du ein eigenes Konto, in dem du siehst, wie es mit deiner Bewerbung weitergeht.',
				consent:
					'Ich willige ein, dass meine Angaben zur Bearbeitung meiner Bewerbung und für meine Beschäftigung bei {event} verarbeitet werden. Ich kann die Einwilligung jederzeit widerrufen.',
				success:
					'Vielen Dank! Wir haben deine Anmeldung erhalten und dir eine E-Mail geschickt. Darin findest du den Link, mit dem du das Passwort für dein Konto festlegst.',
				mail_subject: 'Deine Anmeldung für {event}',
				mail_body:
					'vielen Dank für deine Anmeldung für {event}! Wir haben deine Daten erhalten und melden uns, sobald wir die Bewerbungen durchgesehen haben.',
			},
			sections: {
				personal: { label: 'Abschnitt "Über dich"', title: 'Über dich' },
				address: { label: 'Abschnitt "Adresse"', title: 'Adresse' },
				tax: {
					label: 'Abschnitt "Steuer & Sozialversicherung"',
					title: 'Steuer & Sozialversicherung',
					text: 'Diese Angaben brauchen wir für deine Lohnabrechnung. Du findest sie in der Mitteilung deiner Steuer-ID und auf deinem Sozialversicherungsausweis.',
				},
				bank: {
					label: 'Abschnitt "Bankverbindung"',
					title: 'Bankverbindung',
					text: 'Auf dieses Konto überweisen wir deinen Lohn.',
				},
				work: {
					label: 'Abschnitt "Dein Einsatz"',
					title: 'Dein Einsatz',
					text: 'Wähle alle Tage, an denen du arbeiten kannst. Den genauen Einsatz planen wir später mit dir.',
				},
				motivation: { label: 'Abschnitt "Erfahrung & Motivation"', title: 'Erfahrung & Motivation' },
				consents: { label: 'Abschnitt "Abschluss"', title: 'Abschluss' },
			},
			progress: '{done} von {total} Abschnitten vollständig',
			intro: {
				duration: 'Dauert etwa 10 Minuten',
				secure: 'Verschlüsselt übertragen',
				has_account: 'Schon ein Konto?',
				login: 'Dort anmelden und bewerben',
			},
			days: {
				label: 'Mögliche Arbeitstage',
				all: 'Alle',
				none: 'Keine',
				required: 'Wähle mindestens einen Tag.',
				phase: {
					assembling: 'Aufbau',
					event: 'Veranstaltung',
					dismantling: 'Abbau',
				},
			},
			crews: 'In welchen Bereichen möchtest du am liebsten arbeiten?',
			skills: 'Was bringst du mit?',
			minor_hint:
				'Du bist bei der Veranstaltung noch nicht 18. Das ist in Ordnung - wir brauchen später nur die Einverständniserklärung deiner Erziehungsberechtigten.',
			privacy_before: 'Ich habe die',
			privacy_link: 'Datenschutzerklärung',
			privacy_after: 'gelesen.',
			correct: 'Alle Angaben sind richtig und vollständig. Ändert sich etwas, gebe ich sofort Bescheid.',
			incomplete: 'Noch nicht vollständig: {sections}',
			submit: 'Anmeldung abschicken',
			required_hint: 'Mit * markierte Felder sind Pflichtfelder.',
			done: {
				title: 'Anmeldung abgeschickt',
				spam_hint: 'Keine E-Mail bekommen? Schau bitte auch im Spam-Ordner nach.',
				sent_to: 'Die E-Mail ging an',
				wrong_address: 'Falsche Adresse? Zurück zum Formular und noch einmal abschicken',
			},
			unavailable: {
				invalid: {
					title: 'Dieser Link ist ungültig',
					text: 'Vielleicht wurde er durch einen neuen ersetzt oder die Anmeldung wurde ausgeschaltet.',
				},
				closed: {
					title: 'Die Anmeldung ist geschlossen',
					text: 'Für diese Veranstaltung nehmen wir gerade keine Anmeldungen an.',
				},
			},
			errors: {
				network:
					'Die Anmeldung konnte nicht gesendet werden. Prüfe deine Verbindung und versuch es noch einmal.',
				throttled: 'Zu viele Versuche in kurzer Zeit. Warte bitte eine Minute und versuch es dann noch einmal.',
				unknown: 'Da ist etwas schiefgegangen. Versuch es bitte später noch einmal.',
				reload: 'Bitte lade die Seite neu und schick die Anmeldung noch einmal ab.',
				invalid: 'Bitte prüfe deine Angaben in: {sections}',
			},
		},
	},
	data: {
		user: {
			// Contact data
			middelname: 'Zweiter Vorname',
			sex: 'Geschlecht',
			mobile: 'Telefonnummer',
			address: 'Anschrift',
			street: 'Straße',
			street_number: 'Hausnummer',
			postcode: 'PLZ',
			city: 'Stadt',
			diet: 'Bevorzugte Ernährung',
			allergies: 'Allergien',
			shirt_size: 'T-Shirt-Größe',
			shoe_size: 'Schuhgröße',
			own_shoes: 'Ich habe meine eigenen Sicherheitsschuhe',
			fetsy_code: 'FetSy-Hammertag-Code',
			// Core data
			birthday: 'Geburtsdatum',
			birth_name: 'Geburtsname',
			birth_place: 'Geburtsort',
			citizenship: 'Staatsangehörigkeit',
			employment_status: 'Status der Erwerbstätigkeit',
			employment_status_note: 'Information zur sonstigen Erwerbstätigkeit',
			civil_status: 'Familienstand',
			number_of_children: 'Anzahl der Kinder',
			confession: 'Konfession',
			confession_info: 'Relevant für etwaigen Kirchensteuerabzug',
			social_security_number: 'Sozialversicherungsnummer',
			skip_social_security_number: 'Keine Sozialversicherungsnummer vorhanden',
			tax_category: 'Steuerklasse',
			tax_ident_number: 'Steueridentifikationsnummer / TIN',
			health_insurance_name: 'Krankenkasse',
			health_insurance_type: 'Gesetzlich/Privat',
			bank_name: 'Name der Bank',
			iban: 'IBAN',
			bic: 'BIC',
			// Qualifications
			graduation_type: 'Schulabschluss',
			graduation_name: 'Studium / Ausbildung',
			additional_qualifications: 'zusätzliche Qualifikationen',
			// Driving licence and work permit
			driving_license_classes: 'Führerschein',
			driving_license_checked_at: 'Führerschein gesichtet',
			work_permit: 'Ich habe eine Arbeitserlaubnis für Deutschland',
			work_permit_hint: 'Ohne EU-, EWR- oder Schweizer Staatsangehörigkeit brauchen wir später eine Kopie deines Aufenthaltstitels.',
			// Computed values
			// Under 18 on a day of the event
			minor: 'U18',
			address_data_completed: 'Kontakt Daten',
			core_data_completed: 'Lohn Daten',
			data_completed: 'Kontrolle',
			// Realtions
			skills: 'Fähigkeiten',
			experiences: 'Erfahrungen',
			applications: 'Bewerbungen',
			// Counts
			applications_count: '# Bewerbungen',
			events_count: '# Veranstaltungen',
			assignments: 'Zuordnungen',
			planned_hours: 'Geplante Stunden',
			//
			contract_type: 'Art des Vertrags',
			personnel_type: 'Art des Personals',
			entry_date: 'Erstes Eintrittsdatum',
			active_contract: {
				start_at: 'Startdatum',
				end_at: 'Enddatum',
				wage: 'Stundenlohn',
				state: 'Status',
				available_days: 'Verfügbare Arbeitstage',
				worked_days: 'Gearbeitete Tage',
			},
			contracts: 'Verträge',
			plannings_count: 'Geplante Einsatztage',
			upcoming_events: 'Eingeteilt',
		},
		experience: {
			id: 'Id',
			preview: 'Vorschau',
			name: 'Erfahrung',
			color: 'Farbe',
			description: 'Beschreibung',
			ratings_count: '# Erfahrungseinträge',
			requirements_count: '# Personalanfragen',
		},
		staffing_request_requirement: {
			of_them: 'davon mind.',
			type: 'Art der Anforderung',
			min_level: 'ab',
			min_level_hint: 'Mindestens so viele Sterne. Ohne Sterne genügt es, die Erfahrung überhaupt zu haben.',
		},
		user_skill: {
			id: 'Id',
			preview: 'Vorschau',
			users_count: '# Personen',
			description: 'Beschreibung',
			color: 'Farbe',
			name: 'Name',
		},
		staffing_request: {
			id: 'Id',
			name: 'Veranstaltung',
			start_at: 'Beginn',
			end_at: 'Ende',
			period: 'Zeitraum',
			note: 'Anmerkung',
			status: 'Status',
			persons_total: 'Personentage',
			positions: 'Bedarf',
			created_at: 'Erstellt am',
			user: {
				firstname: 'Vorname',
				lastname: 'Nachname',
			},
		},
		staffing_request_position: {
			persons: 'Personen',
			qualification: 'Qualifikation',
			personnel_type: 'Art des Personals',
			note: 'Anmerkung',
			sum: 'Summe',
			any: 'Ohne Vorgabe',
		},
		application: {
			id: 'Id',
			warning: '',
			user: {
				avatar: '',
				firstname: 'Vorname',
				lastname: 'Nachname',
				email: 'E-Mail-Adresse',
				mobile: 'Telefonnummer',
				address: 'Anschrift',
				personnel_type: 'Art des Personals',
				sex: 'Geschlecht',
				postcode: 'PLZ',
				city: 'Stadt',
				skills: 'Fähigkeiten',
				diet: 'Bevorzugte Ernährung',
				allergies: 'Allergien',
				shirt_size: 'T-Shirt-Größe',
				shoe_size: 'Schuhgröße',
				//
				birthday: 'Geburtsdatum',
				birth_name: 'Geburtsname',
				birth_place: 'Geburtsort',
				citizenship: 'Staatsangehörigkeit',
				driving_license_classes: 'Führerschein',
			},
			event: {
				name: 'Veranstaltung',
				assembling_start_at: 'Aufbau ab',
				dismantling_end_at: 'Abbau bis',
			},
			distance: 'Distanz',
			available_from: 'Verfügbar von',
			available_until: 'Verfügbar bis',
			planned_days: 'Geplante Einsatztage',
			crews: 'Crews',
			state: 'Status',
			motivation: 'Motivation',
			experience: 'Erfahrungen',
			user_plannings_count: 'Geplante Einsatztage',
			minor: 'U18',
			source: 'Herkunft',
			days: 'Mögliche Arbeitstage',
			arrival_type: 'Anreise',
			employment_preference: 'Gewünschte Beschäftigungsart',
		},
		event: {
			//
			description: 'Beschreibung',
			company_name: 'Firmenname, c/o Adresse',
			legalname: 'Firmenname',
			street: 'Straße',
			street_number: 'Hausnummer',
			postalcode: 'Postleitzahl',
			city: 'Stadt',
			status: 'Status',
			//
			applications_count: '# Bewerbungen',
			crews_count: '# Crews',
			employees: 'Personen',
			planned_hours: 'Geplante Stunden',
			plannings_count: 'Geplante Einsatztage',
			user_plannings_count: 'Geplante Einsatztage',
		},
		crew: {
			id: 'Id',
			name: 'Name',
			start_at: 'Start',
			end_at: 'Ende',
			projectnumber: 'Projektnummer',
			image: 'Bild',
			description: 'Beschreibung',
			event: {
				name: 'Veranstaltung',
			},
			managers: 'Crew-Leitung',
			minimal_employee_counts_sum_count: 'Benötigte Personentage',
			plannings_count: 'Geplante Personentage',
			project_number: 'Projektnummer',
			timetracking: 'Zeiterfassung',
		},
		subscription: {
			user: {
				firstname: 'Vorname',
				lastname: 'Nachname',
				status: 'Status',
				postcode: 'PLZ',
				city: 'Stadt',
				skills: 'Fähigkeiten',
				experiences: 'Erfahrungen',
			},
			event: {
				name: 'Veranstaltung',
				assembling_start_at: 'Aufbau ab',
				dismantling_end_at: 'Abbau bis',
			},
			application: {
				status: 'Status der Bewerbung',
			},
			distance: 'Distanz',
		},
		additional_occupation: {
			employer: 'Arbeitgeber',
			weekly_hours: 'Stunden/Woche',
			work_start_at: 'Beginn',
			work_end_at: 'Ende',
			type_of_work: 'Beschäftigungsart',
		},
		contract: {
			start_at: 'Startdatum',
			end_at: 'Enddatum',
			wage: 'Stundenlohn',
			state: 'Status',
			data_completed: 'Kontrolle',
			available_days: 'Verfügbare Arbeitstage',
			worked_days: 'Gearbeitete Tage',
		},
		timetracking: {
			id: 'Id',
			date: 'Datum',
			start_at: 'Arbeitsstart',
			end_at: 'Arbeitsende',
			worked: 'Arbeitszeit',
			pause: 'Pausenzeit',
			event: {
				name: 'Veranstaltung',
			},
			crew: {
				name: 'Crew',
			},
			firstname: 'Vorname',
			lastname: 'Nachname',
			is_planned: 'Einsatztag',
			note: 'Notiz',
			user: {
				lastname: 'Nachname',
				firstname: 'Vorname',
			},
			lead_review: 'Crew-Leitung',
			member_review: 'Crew-Mitglied',
			own_record: 'Selbst eingetragen',
		},
		payroll: {
			id: 'Id',
			firstname: 'Vorname',
			lastname: 'Nachname',
			active_contract: {
				state: 'Status Vertrag',
				start_at: 'Startdatum',
				end_at: 'Enddatum',
			},
			data_completed: 'Kontrollen',
			hours_confirmed: 'Bestätigte Stunden',
			hours_total: 'Gesamtstunden',
			work_hours: 'Gesetzte Stunden',
			travel_expenses: 'Reisekosten',
			external_expenses: 'Auslagen',
			tip: 'Trinkgeld',
			state: 'Status',
			timetracking: 'Zeiterfassung',
			checked: 'Geprüft',
		},
		file: {
			id: 'Id',
			name: 'Bezeichnung',
			type: 'Kategorie',
			edit_type: 'Kategorie bearbeiten',
			created_at: 'Hochgeladen am',
			read_at: 'Gesehen am',
			mimetype: 'Datentyp',
			uploaded_by: 'Hochgeladen von',
		},
		user_date: {
			name: 'Bezeichnung',
			date: 'Datum',
			color: 'Farbe',
			note: 'Notiz',
		},
	},
	enums: {
		user: {
			sex: {
				null: '',
				male: 'männlich',
				female: 'weiblich',
				diverse: 'divers',
			},
			diet: {
				no_preference: 'Keine Präferenzen',
				vegetarian: 'Vegetarische Ernährung',
				vegan: 'Vegane Ernährung',
				kosher: 'Koschere Ernährung',
			},
			tax_category: {
				1: '1 / I',
				2: '2 / II',
				3: '3 / III',
				4: '4 / IV',
				5: '5 / V',
				6: '6 / VI',
			},
			employment_status: {
				pupil: 'Schüler/in',
				unemployed: 'arbeitslos und beziehe Bürgergeld/ALG1',
				self_employed: 'hauptberuflich selbständig',
				employee: 'Voll-/Teilzeitarbeitnehmer/in',
				student: 'Ich studiere Vollzeit',
				waiting_after_school:
					'Ich habe dieses Jahr meinen Schulabschluss gemacht und warte auf den Ausbildungs-/Studiumsbeginn.',
				waiting_after_voluntary_service:
					'Ich habe dieses Jahr meinen Freiwilligendienst beendet und warte auf den Ausbildungs-/Studiumsbeginn.',
				other: 'Sonstiges',
				apprentice: 'Auszubildende/r',
				dual_student: 'Duales Studium',
			},
			type_of_work: {
				marginal: 'geringfügige Entlohnung',
				non_marginal: 'nicht geringfügige Entlohnung',
				short_term: 'kurzfristige Beschäftigung',
			},
			civil_status: {
				single: 'ledig',
				married: 'verheiratet',
				widowed: 'verwitwet',
				divorced: 'geschieden',
				registered_partnership: 'eingetragene Lebenspartnerschaft',
			},
			health_insurance_type: {
				statutory: 'Gesetzlich',
				private: 'Privat',
			},
			contract_type: {
				short_term: 'Kurzfristige Beschäftigung',
				permanent: 'Festanstellung',
			},
			personnel_type: {
				helper: 'Helfer',
				freelancer: 'Freelancer',
			},
			driving_license_classes: {
				none: 'Keinen',
				a1: 'A1 - Leichtkraftrad',
				a2: 'A2 - Motorrad bis 35 kW',
				a: 'A - Motorrad',
				b: 'B - Pkw bis 3,5 t',
				be: 'BE - Pkw mit Anhänger',
				c1: 'C1 - Lkw bis 7,5 t',
				c1e: 'C1E - C1 mit Anhänger',
				c: 'C - Lkw',
				ce: 'CE - Lkw mit Anhänger',
				d1: 'D1 - Kleinbus',
				d1e: 'D1E - D1 mit Anhänger',
				d: 'D - Bus',
				de: 'DE - Bus mit Anhänger',
				l: 'L - Zugmaschine bis 40 km/h',
				t: 'T - Traktor bis 60 km/h',
			},
		},
		application: {
			source: {
				app: 'App',
				quick_registration: 'Schnellanmeldung',
			},
			source_hint: {
				quick_registration: 'Über die öffentliche Schnellanmeldung, Konto mit angelegt',
			},
			arrival_type: {
				car_parking: 'Mit dem Auto',
				car_drop_off: 'Ich werde gebracht',
				car_sleeping: 'Mit dem Auto, ich schlafe darin',
				no_car: 'Ohne Auto',
			},
			arrival_type_hint: {
				car_parking: 'Ich brauche einen Parkplatz für die ganze Zeit.',
				car_drop_off: 'Ich werde gebracht und abgeholt, ein Parkplatz ist nicht nötig.',
				car_sleeping: 'Ich übernachte im Auto auf dem Gelände.',
				no_car: 'Mit Bahn, Bus, Rad oder zu Fuß.',
			},
			employment_preference: {
				marginal: 'Minijob',
				short_term: 'Kurzfristig',
				invoice: 'Auf Rechnung',
			},
			employment_preference_hint: {
				marginal: 'Geringfügige Beschäftigung',
				short_term: 'Kurzfristige Beschäftigung, höchstens 70 Tage im Jahr',
				invoice: 'Selbständig, du stellst eine Rechnung',
			},
		},
		staffing_request: {
			requirement_type: {
				experience: 'Erfahrung',
				skill: 'Fähigkeit',
				driving_license: 'Führerschein',
			},
			status: {
				open: 'Offen',
				in_progress: 'In Bearbeitung',
				done: 'Erledigt',
				declined: 'Abgelehnt',
			},
		},
		event_label: {
			locked: 'Gesperrt',
			not_published: 'Nicht veröffentlicht',
			disable_application: 'Bewerbung nicht freigegeben',
			is_expired: 'Abgeschlossen',
			is_archived: 'Archiviert',
		},
	},
	tabs: {
		admin_settings: {
			skills: 'Fähigkeiten',
			experiences: 'Erfahrungen',
			user_dashboard: 'Startseite',
			datev: 'DATEV',
			contracts: 'Verträge',
			// Ohne Briefpapier in dieser App nur das Mail-Design (app_eflib, extension letterhead).
			design: 'Mail-Design',
			groups: {
				staff: 'Personal',
				appearance: 'Darstellung',
				system: 'System',
			},
		},
		event_settings: {
			general: 'Allgemein',
			info: 'Mitarbeitendeninformation',
			crews: 'Crews',
			quick_registration: 'Schnellanmeldung',
			users: 'Personen',
		},
		crew_settings: {
			general: 'Allgemein',
			users: 'Personen',
			info: 'Mitarbeitendeninformation',
			ratings: 'Erfahrungen',
			planning: 'Personalplanung',
			timetracking: 'Zeiterfassung',
		},
		user_settings: {
			contact_data: 'Kontaktdaten',
			core_data: 'Steuer- und Lohndaten',
			additional_occupations: 'Qualifikationen',
			qualifications: 'Qualifikationen',
			experiences: 'Erfahrungen',
			files: 'Dokumente',
			contracts: 'Verträge',
			events: 'Veranstaltungen',
			timetracking: 'Zeiterfassung',
			calendar: 'Kalender',
		},
		user_mails: {
			inbox: 'Posteingang',
			outbox: 'Postausgang',
		},
		hr_mails: {
			inbox: 'Posteingang',
			outbox: 'Postausgang',
		},
	},
	validations: {
		iban: 'IBAN ungültig',
		tax_ident_number: 'Steueridentifikationsnummer ungültig',
		sv_number: 'Sozialversicherungsnummer ungültig',
		sv_number_birthday: 'Passt nicht zum Geburtsdatum',
		phone: 'Telefonnummer ungültig',
		min_age: 'Du musst mindestens 16 Jahre alt sein',
		bic: 'BIC ungültig',
		datev_accountant_id: 'Ungültige Beraternummer',
		datev_client_id: 'Ungültige Mandantennummer',
		valid_email: 'Ungültige E-Mail-Adresse',
		valid_postcode: 'Postleitzahl nicht gefunden',
		end_before_start: 'Das Ende darf nicht vor dem Beginn liegen',
	},
	filters: {
		event: 'Veranstaltung',
		crew: 'Crew',
		user_skill: 'Fähigkeiten',
		experience: 'Erfahrung',
		driving_license: 'Führerschein',
		application_state: 'Bewerbungsstatus',
		application_source: 'Herkunft',
		experience_any_level: 'Sterne egal',
		experience_from_level: 'ab',
		crew_mode: {
			all: 'Alle',
			planned: 'Eingeplant',
			preferred: 'Bevorzugt',
		},
		timetracking: {
			day: 'Tag',
			person: 'Person',
			state: 'Status',
			states: {
				open: 'Offen',
				lead: 'Von Crew-Leitung bestätigt',
				member: 'Von Crew-Mitglied bestätigt',
				complete: 'Vollständig',
				lead_disputed: 'Crew-Leitung: passt nicht',
				member_disputed: 'Crew-Mitglied: passt nicht',
			},
			event_day: 'Veranstaltungstag',
		},
	},
	modals: {
		edit_staffing_request: {
			create: 'Neue Personalanfrage',
			edit: 'Personalanfrage bearbeiten',
			general: 'Allgemein',
			demand: 'Benötigte Personen pro Tag',
			no_positions: 'Noch kein Bedarf angegeben.',
			period_hint: 'Bitte zuerst einen Zeitraum wählen.',
			requirements_hint:
				'Unter „Personen“ steht, wie viele Leute eine Zeile pro Tag braucht. Die Zeilen „davon mind.“ sagen, wie viele von ihnen etwas mitbringen müssen. Sie kommen nicht dazu, und eine Person kann mehrere erfüllen.',
			exceeds: 'Mehr als die {count} Personen der Zeile an diesem Tag',
			blocked: 'Speichern geht erst, wenn das behoben ist:',
			missing_target:
				'Bei einer Zeile „davon mind.“ fehlt noch, was gefordert ist. | Bei {count} Zeilen „davon mind.“ fehlt noch, was gefordert ist.',
			exceeded_days:
				'An einem Tag fordert eine Zeile „davon mind.“ mehr Personen, als die Zeile hat. | An {count} Tagen fordert eine Zeile „davon mind.“ mehr Personen, als die Zeile hat.',
		},
		edit_experience: {
			create: 'Neue Erfahrung anlegen',
			edit: 'Erfahrung bearbeiten',
			description_placeholder:
				'Woran eine Crew-Leitung die Sterne festmacht, z. B. Schankanlage bedienen und reinigen',
		},
		edit_user_skill: {
			create: 'Neue Fähigkeit anlegen',
			edit: 'Fähigkeit editieren',
		},
		edit_additional_occupation: {
			create: 'Weitere Beschäftigung hinzufügen',
			edit: 'Weitere Beschäftigung bearbeiten',
			delete_title: 'Beschäftigung löschen',
			delete_text: 'Soll die Beschäftigung bei „{item}" wirklich gelöscht werden?',
		},
		show_application_info: {
			consented_at: 'Eingewilligt am {date}',
			title: 'Details zur Bewerbung von {fullname}',
		},
		compose_mail: {
			title: 'Nachricht senden',
			to: 'An',
			direct_message: 'Direktnachricht',
			hr_team: 'HR-Team',
			subscribers: 'Alle Abonnenten vom {event}',
			sent_to: 'Kein Abonnent erreicht | An einen Abonnenten gesendet | An {count} Abonnenten gesendet',
			subject: 'Betreff',
			subject_placeholder: 'Betreff eingeben …',
			subject_required: 'Bitte gib einen Betreff ein',
			message: 'Nachricht',
			message_placeholder: 'Nachricht schreiben …',
			message_required: 'Bitte gib eine Nachricht ein',
			send: 'Senden',
		},
		edit_crew: {
			create: 'Neue Crew anlegen',
			edit: 'Crew editieren',
		},
		assign_to_event: {
			title: '{name} zu einer Veranstaltung hinzufügen',
			ok: 'Hinzufügen',
			hint: 'Die Person wird Mitglied der Veranstaltung, ohne Bewerbung. Crew und Tage teilst du danach in der Personalplanung zu.',
			no_events: 'Es gibt keine laufende oder kommende Veranstaltung.',
			booked: 'schon eingeteilt',
			running: 'läuft',
			done: '{name} ist jetzt bei {event} dabei',
		},
		add_staff: {
			title: 'Person hinzufügen',
			input: 'Person auswählen',
		},
		invite_to_event: {
			title: 'Person einladen oder hinzufügen',
			email: 'Suche nach Name oder Mail-Adresse',
		},
		create_event: {
			title: 'Veranstaltung anlegen',
		},
		review_timetracking: {
			confirm: {
				title: 'Zeiten bestätigen',
				ok: 'Bestätigen',
				text_lead: 'Bestätigst du die Zeiten von {name} als Crew-Leitung?',
				text_member: 'Bestätigst du, dass deine Zeiten stimmen?',
				placeholder: 'Optional',
				final_now_lead:
					'Das Crew-Mitglied hat die Zeiten schon bestätigt. Mit deiner Bestätigung sind sie endgültig und können nicht mehr geändert werden.',
				final_now_member:
					'Die Crew-Leitung hat die Zeiten schon bestätigt. Mit deiner Bestätigung sind sie endgültig und können nicht mehr geändert werden.',
				final_later_lead:
					'Sobald auch das Crew-Mitglied bestätigt, sind die Zeiten endgültig und können nicht mehr geändert werden.',
				final_later_member:
					'Sobald auch die Crew-Leitung bestätigt, sind die Zeiten endgültig und können nicht mehr geändert werden.',
			},
			dispute: {
				title: 'Zeiten passen nicht',
				ok: 'Melden',
				text_lead:
					'Was passt an den Zeiten von {name} nicht? Du kannst die Zeiten danach in der Zeiterfassung korrigieren, {name} bestätigt sie dann noch einmal.',
				text_member:
					'Was passt an deinen Zeiten nicht? Die Crew-Leitung sieht deine Notiz und kann die Zeiten korrigieren. Danach bestätigst du sie noch einmal.',
				placeholder: 'Zum Beispiel: Ende war 18:00',
			},
		},
		edit_timetracking: {
			title: 'Zeiten von {name} ändern',
			minutes: 'Minuten',
			end_before_start: 'Das Arbeitsende liegt vor dem Arbeitsstart.',
			member_again: 'Nach dem Speichern muss {name} die geänderten Zeiten noch einmal bestätigen.',
		},
		edit_own_timetracking: {
			title: 'Zeiten korrigieren',
			day: 'Einsatztag',
			not_planned:
				'Du bist an diesem Tag nicht mehr in der Crew eingeteilt, deshalb kannst du die Zeiten hier nicht mehr ändern. Sprich dafür deine Crew-Leitung an.',
			next_day: 'Endet am Folgetag, {day}.',
			too_long: 'Ein Arbeitstag dauert höchstens 24 Stunden.',
			confirm_hint:
				'Mit dem Speichern bestätigst du deine Zeiten. Danach bestätigt sie die Crew-Leitung; bis dahin kannst du sie noch ändern.',
			after_now: 'Das Ende darf nicht nach der aktuellen Uhrzeit liegen.',
		},
		clock_out_timetracking: {
			title: 'Ausstempeln',
			forgot: 'Du bist seit {start} eingestempelt. Trag ein, wann du aufgehört hast; vorgeschlagen ist das Ende der erlaubten Höchstarbeitszeit.',
			before_start: 'Das Ende muss nach dem Einstempeln liegen.',
			after_now: 'Das Ende darf nicht nach der aktuellen Uhrzeit liegen.',
			too_long: 'Zwischen Ein- und Ausstempeln liegen höchstens 24 Stunden.',
		},
		clock_in_timetracking: {
			title: 'Einstempeln',
			after_now: 'Der Beginn darf nicht nach der aktuellen Uhrzeit liegen.',
		},
	},
	popovers: {
		event: {
			not_published: {
				title: 'Veranstaltung nicht veröffentlicht',
				text: 'Die Veranstaltung wurde noch nicht veröffentlicht. Erst danach ist die Bewerbung aktiv.',
			},
			expired: {
				title: 'Veranstaltung liegt in der Vergangenheit',
				text: 'Die Veranstaltung liegt in der Vergangenheit. Die Bewerbung ist nicht mehr möglich.',
			},
		},
		user: {
			min_age: {
				title: 'Minderjährig',
				text: 'Die Person ist an mindestens einem Tag der Veranstaltung noch nicht 18 und kann nicht für alle Aufgaben eingesetzt werden.',
			},
			shirt_size: {
				title: 'T-Shirt-Größe',
				text: 'Die Größe, in der du Arbeits- und Veranstaltungs-T-Shirts bekommst.',
			},
			address_data_completed: {
				true: {
					title: 'Adressdaten vollständig',
					text: 'Die Adressdaten der Person sind vollständig hinterlegt',
				},
				false: {
					title: 'Adressdaten unvollständig',
					text: 'Es sind nicht alle Adressdaten der Person hinterlegt',
				},
			},
			core_data_completed: {
				true: {
					title: 'Stammdaten vollständig',
					text: 'Die Stammdaten der Person sind vollständig hinterlegt',
				},
				false: {
					title: 'Stammdaten unvollständig',
					text: 'Es sind nicht alle Stammdaten der Person hinterlegt',
				},
			},
			timetracking_counts: {
				none: {
					title: 'Keine Zeiten erfasst',
					text: 'Es sind keine Zeiten für die Person erfasst',
				},
				missing_lead: {
					title: 'Nicht von der Crew-Leitung bestätigt',
					text: 'Die Crew-Leitung hat nicht alle Zeiten bestätigt',
				},
				missing_member: {
					title: 'Nicht von der Person bestätigt',
					text: 'Die Person hat nicht alle Zeiten bestätigt',
				},
				completed: {
					title: 'Alle Zeiten bestätigt',
					text: 'Crew-Leitung und Person haben alle Zeiten bestätigt',
				},
			},
		},
		timetracking: {
			reviewed_by: '{date} von {name}',
			lead: {
				open: 'Crew-Leitung: offen',
				confirmed: 'Von der Crew-Leitung bestätigt',
				disputed: 'Crew-Leitung: passt nicht',
				waiting: 'Die Crew-Leitung hat die Zeiten noch nicht bestätigt.',
			},
			member: {
				open: 'Crew-Mitglied: offen',
				confirmed: 'Vom Crew-Mitglied bestätigt',
				disputed: 'Crew-Mitglied: passt nicht',
				waiting: 'Das Crew-Mitglied hat die Zeiten noch nicht bestätigt.',
			},
		},
	},
	confirms: {
		delete_registration_background: {
			title: 'Hintergrundbild löschen?',
			text: 'Das Bild verschwindet sofort von der Anmeldeseite, nicht erst mit Speichern.',
		},
		renew_registration_link: {
			title: 'Neuen Link erzeugen',
			text: 'Der bisherige Link zur Schnellanmeldung funktioniert danach nicht mehr, auch nicht auf schon gedruckten Aushängen. Fortfahren?',
		},
		delete_staffing_request: {
			title: 'Personalanfrage löschen',
			text: 'Soll die Personalanfrage für "{item}" wirklich entfernt werden?',
		},
		delete_experience: {
			title: 'Erfahrung löschen',
			text: 'Soll die Erfahrung "{item}" wirklich gelöscht werden?',
		},
		delete_experience_rating: {
			title: 'Erfahrungseintrag entfernen',
			text: 'Soll der Eintrag in "{experience}" aus der Crew {crew} ({event}) wirklich entfernt werden? Die Stufe wird neu berechnet.',
		},
		delete_user_skill: {
			title: 'Fähigkeit löschen',
			text: 'Soll die Fähigkeit "{item}" zur Auswahl in den Personen Qualifikationen entfernt werden?',
		},
		delete_file: {
			title: 'Datei löschen',
			text: 'Soll die Datei "{item}" wirklich entfernt werden?',
		},
		reset_user_core_data: {
			title: 'Steuer- und Lohndaten löschen',
			text: 'Sollen die Steuer- und Lohndaten der Person "{item}" wirklich entfernt werden? Der Vorgang kann nicht rückgängig gemacht werden.',
		},
		delete_subscription: {
			title: 'Abo löschen',
			text: 'Soll das Abo für die Veranstaltung "{item}" wirklich entfernt werden?',
		},
		publish_application: {
			title: 'Zu- oder Absage versenden',
			text: 'Soll die Zu- oder Absage an "{item}" versendet werden? Der Vorgang kann nicht rückgängig gemacht werden.',
		},
		publish_many_applications: {
			title: 'Zu- oder Absagen versenden',
			text: 'Sollen die Zu- und Absagen wirklich gesendet werden? Der Vorgang kann nicht rückgängig gemacht werden.',
		},
		delete_crew: {
			title: 'Crew löschen',
			text: 'Soll die Crew "{item}" wirklich gelöscht werden?',
		},
		remove_event_user: {
			title: 'Person entfernen',
			text: 'Soll {name} aus der Veranstaltung {event} entfernt werden? Bewerbungen und Einsätze bleiben.',
		},
		lock_event: {
			title: 'Veranstaltung sperren',
			text: '„{event}“ sperren? Danach kann niemand mehr etwas daran ändern, auch HR nicht: keine Bewerbungen, Abos, Planungen, Crews oder Zeiten. Entsperren geht jederzeit hier.',
		},
		export_payroll: {
			title: 'LODAS-Datei exportieren',
			text: 'Alle geprüften Abrechnungen vom {month}, die noch in keinem Export waren, kommen mit den Stammdaten ihrer Personen in die Datei. Danach gelten sie als exportiert, sind nicht mehr änderbar und fehlen in jedem weiteren Export.',
		},
		check_payslip: {
			title: 'Abrechnung prüfen',
			text: 'Die Abrechnung von „{item}“ als geprüft stempeln? Danach lässt sie sich nicht mehr ändern und geht mit dem nächsten Export an DATEV.',
		},
		uncheck_payslip: {
			title: 'Prüfung zurücknehmen',
			text: 'Die Prüfung der Abrechnung von „{item}“ zurücknehmen? Sie lässt sich dann wieder bearbeiten und kommt erst nach einer neuen Prüfung in den Export.',
		},
		delete_own_timetracking: {
			title: 'Zeiten löschen',
			text: 'Sollen deine Zeiten vom {day} in der Crew "{crew}" wirklich gelöscht werden?',
		},
	},
	user_removal: {
		reasons: {
			open_payslips: '{count} Abrechnung(en) sind noch nicht exportiert.',
			unsettled_months: 'Zeiterfassungen ohne exportierte Abrechnung in: {months}.',
			time_trackings: '{count} Zeiterfassung(en) - die Person hat gearbeitet.',
			payslips: '{count} Abrechnung(en) müssen erhalten bleiben.',
			contracts: '{count} Vertrag/Verträge müssen erhalten bleiben.',
			applications: '{count} Bewerbung(en) für Events.',
		},
	},
	notifications: {
		application_accepted: {
			icon: 'fa-campground',
			title: 'Bewerbung akzeptiert',
			text: 'Deine Bewerbung wurde angenommen. Willkommen im Team!',
		},
		application_created: {
			icon: 'fa-campground',
			title: 'Bewerbung eingegangen',
			text: 'Deine Bewerbung ist bei uns eingegangen. Danke!',
		},
		application_declined: {
			icon: 'fa-campground',
			title: 'Bewerbung abgelehnt',
			text: 'Deine Bewerbung wurde leider abgelehnt.',
		},
		application_reactivated: {
			icon: 'fa-campground',
			title: 'Bewerbung wieder aktiviert',
			text: 'Deine Bewerbung ist wieder aktiviert. Super!',
		},
		application_revoked: {
			icon: 'fa-campground',
			title: 'Bewerbung zurückgezogen',
			text: 'Du hast deine Bewerbung zurückgezogen. Schade!',
		},
		application_waiting: {
			icon: 'fa-campground',
			title: 'Bewerbung auf der Warteliste:',
			text: 'Wir haben deine Bewerbung auf die Warteliste gesetzt. Danke!',
		},
		contract_send: {
			icon: 'fa-file-signature',
			title: 'Vertrag verfügbar',
			text: 'Deinen Vertrag haben wir dir bei deinen Dokumenten hochgeladen.',
		},
		event_published: {
			icon: 'fa-campground',
			title: 'Neues Jobangebot',
			text: 'Bei Interesse bewirb dich jetzt.',
		},
		file_uploaded: {
			icon: 'fa-file',
			title: 'Neues Dokument hochgeladen',
			text: 'Es wurde ein neues Dokument für dich hochgeladen',
		},
	},
	components: {
		star_rating: {
			stars: 'keine Sterne | 1 Stern | {count} Sterne',
			of_five: '{value} von 5 Sternen',
			none: 'Keine Erfahrung eingetragen',
			clear: 'Eintrag zurücknehmen',
		},
		experience_pill: {
			ratings: 'kein Eintrag | 1 Eintrag | {count} Einträge',
			override: 'von HR festgelegt',
		},
		staffing_requirement: {
			licence: 'Führerschein {class}',
			at_least: '≥ {count}',
		},
		// efOccupiedDaysNote, naming what lies on the days in crewadmin
		occupied_days: {
			note: 'Vom {first} bis {last} ist schon etwas gebucht (Einsätze, Zeiten, Bewerbungstage). Der Zeitraum muss diese Tage einschließen.',
		},
		benefits_badge: {
			label: 'ALG',
			unemployed:
				'Arbeitslos, bezieht Bürgergeld/ALG 1 - der Verdienst wird angerechnet, Einsätze mit der Person abstimmen',
		},
		planning_scheduler: {
			needed_staff: 'Benötigtes Personal',
			total: 'Gesamt:',
			employees: 'Mitarbeitende',
			applications: 'Bewerbungen',
			crews: 'Crews',
			preferred_crews: 'Bevorzugte Crews',
			other_crews: 'Weitere Crews',
			not_available: 'Nicht verfügbar',
			other_event: 'Andere VA',
			planned: 'Eingeteilt',
			year_count:
				'{count} Einsatztage im Jahr {year} geplant, über alle Veranstaltungen. Bis 70 Tage geht eine kurzfristige Beschäftigung.',
			year_count_over:
				'{count} Einsatztage im Jahr {year} geplant, über alle Veranstaltungen: mehr als die 70 Tage einer kurzfristigen Beschäftigung.',
			export_name: 'Name',
		},
		minor_badge: {
			label: 'U18',
			minor: 'Minderjährig während der Veranstaltung - nicht für alle Aufgaben einsetzbar',
			minor_until: 'Minderjährig bis kurz vor dem {date} - bis dahin nicht für alle Aufgaben einsetzbar',
			unknown: 'Das Geburtsdatum fehlt noch, das Alter ist unbekannt',
			unknown_label: 'Alter?',
		},
		tax_fields: {
			tax_category_title: 'Gib im Feld "Steuerklasse" bitte an, wie wir dich abrechnen müssen!',
			tax_category_text:
				'Trag keinesfalls einfach die Steuerklasse ein, die du bei einem anderen Arbeitgeber hast. Eine falsche Steuerklasse führt zu Nachberechnungen und Kosten, die wir dir in Rechnung stellen können. Informiere dich bitte vorher, welche Steuerklasse für dich richtig ist. Zur groben Orientierung:',
			tax_category_six:
				'Steuerklasse 6: wenn du eine weitere Beschäftigung hast, die schon über Steuerklasse 1 abgerechnet wird.',
			tax_category_one: 'Steuerklasse 1: wenn du keiner weiteren Beschäftigung nachgehst.',
		},
		occupations: {
			hint: 'Gib deine weiteren Beschäftigungen an. Dies ist für deine Abrechnung relevant.',
		},
		driving_license_select: {
			label: 'Führerscheinklassen',
		},
		upcoming_events: {
			running: 'läuft',
			coming: 'kommt',
			days: 'kein Einsatztag | 1 Einsatztag | {count} Einsatztage',
			member_only: 'hinzugefügt, noch keine Tage geplant',
			leads: 'leitet {crews}',
		},
		event_locked_note: {
			text: 'Diese Veranstaltung ist gesperrt. Bis HR sie unter Veranstaltungen entsperrt, kann hier nichts geändert werden.',
			since: 'Gesperrt seit {date}.',
		},
		time_tracking_tally: {
			summary: '{open} offen, {disputed} passen nicht',
		},
		working_time_hints: {
			over_max: 'Mehr als die erlaubten {hours} Stunden Arbeitszeit am Tag.',
			break_short: 'Für {worked} Arbeitszeit sind mindestens {minutes} Minuten Pause vorgeschrieben.',
			rules: 'Arbeitszeitgesetz: {short} Min. Pause ab {shortAfter} h, {long} Min. ab {longAfter} h Arbeitszeit, höchstens {max} h am Tag.',
		},
		time_tracking_clock: {
			since: 'Eingestempelt seit {start}',
			forgot: 'Du hast vergessen, dich auszustempeln. Trag beim Ausstempeln ein, wann du aufgehört hast.',
			so_far: 'Bisher gearbeitet',
			after_break: '(nach {minutes} Min. Soll-Pause)',
			latest_end: 'Höchstarbeitszeit {hours} h: spätestens um {end} Uhr ausstempeln',
			max: 'Höchstarbeitszeit {hours} h am Tag',
			breaks: 'Soll-Pausen: {short} Min. ab {shortAfter} h, {long} Min. ab {longAfter} h Arbeitszeit',
			today: 'Heute in der Crew {crew}',
			recorded: 'Heute erfasst in der Crew {crew}: {times}',
			not_planned: 'Heute bist du in keiner Crew eingeteilt, deshalb kannst du nicht einstempeln.',
		},
	},
};
